import { createFileRoute } from '@tanstack/react-router';
import LaneCreateView from '../terminal/LanesView/components/LaneCreateView';
export const Route = createFileRoute('/terminals/lanes/create')({ component: LaneCreateView });
